import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";

import { getPaymentFromSessionStorage } from "@/features/payment/utils.ts";
import { Footer, Header, Page } from "@/components/page.tsx";
import { LoadingSpinner } from "@/components/spinner.tsx";
import { useApplyPayment } from "@/hooks/use-apply-payment";
import { useAudioSlot } from "@/features/audio/kiosk-audio";
import {
  BalancePaymentConfirm,
  BalancePaymentHelpText,
  priceSchema,
} from "@/features/payment/balance-payment-confirm";

export const Route = createFileRoute("/payment-balance-screen")({
  component: RouteComponent,
  loader: () => {
    const payment = getPaymentFromSessionStorage();
    const price = z
      .string()
      .transform((elem) => JSON.parse(elem))
      .pipe(priceSchema)
      .safeParse(sessionStorage.getItem(`price`) ?? "").data;

    if (!payment || !price) {
      throw redirect({
        to: "/start-screen",
      });
    }
    return { payment, price };
  },
});

function RouteComponent() {
  useAudioSlot("page.payment-balance");
  const { payment, price } = Route.useLoaderData();
  const navigate = useNavigate();
  const applyPayment = useApplyPayment();

  return (
    <Page className={`bg-background`}>
      {applyPayment.isPending && <LoadingSpinner />}
      <Header
        backArrowHref={`/payment-selector-screen/${payment?.machineId}`}
      />
      <BalancePaymentConfirm
        price={price}
        pending={applyPayment.isPending}
        onConfirm={() =>
          applyPayment.mutate(
            { payment, purchaseType: "BALANCE" },
            { onSuccess: () => navigate({ to: "/payment-complete" }) },
          )
        }
      />
      <Footer helpText={<BalancePaymentHelpText />} />
    </Page>
  );
}
